var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsOnHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ej0HSPqVurf1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46 42",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 46,
    height: 42,
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 42,
    rx: 0,
    ry: 0,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,5.5h23c2.2,0,4,1.8,4,4v23c0,2.2-1.8,4-4,4h-23c-2.2,0-4-1.8-4-4v-23c0-2.2,1.8-4,4-4Z",
    fill: "#597893"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.4,14.4c-2.3,0-4.2,1.9-4.2,4.2v6c0,2.3,1.9,4.2,4.2,4.2h6c2.3,0,4.2-1.9,4.2-4.2v-3c0-.3.3-.6.6-.6s.6.3.6.6v3c0,3-2.4,5.4-5.4,5.4h-6.1c-3,0-5.4-2.4-5.4-5.4v-6c0-3,2.4-5.4,5.4-5.4h3c.3,0,.6.3.6.6c0,.4-.3.6-.6.6c0,0-2.9,0-2.9,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,15.6c0,2-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6v0c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,2h.8c1.7,0,3,1.4,3,3v32c0,1.7-1.4,3-3,3h-.8L0,2Z",
    fill: "#597893"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsOnHover);
export default __webpack_public_path__ + "static/media/AppsOnHover.8ba482919b678ef5fb571bdc37893090.svg";
export { ForwardRef as ReactComponent };